<template>
<div style="height: 1400px;">
  <v-form v-model="formValid">
    <v-jsonschema-form v-if="schema" :schema="schema" :model="dataObject" :options="options"

     />
     <v-btn @click="postNow1">submit</v-btn>
  </v-form>
  </div>
</template>

<script>
export default {
data () {
    return {
      schema: {},
      dataObject: {},
      formValid: false,
      options: {
        debug: false,
        disableAll: false,
        autoFoldObjects: true
      }
    }

  },
   mounted() {
    if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
    this.$http
      .get(this.$root.apiUrl+'/api/v1/schemas/instances.json')
      .then(response => (this.schema = response.data));
      // console.log(this.schema);
  },
    methods: {
  	postNow1: function() {
    if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
      this.$http
      .post(this.schema.uri_api, this.dataObject)
      .then(r => {
          // console.log('r: ', JSON.stringify(r, null, 2));
          this.$router.push({ name: 'instances' })
      });

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/instances/add.vue